require('./openYoungHistoryView.scss');

// @vendors
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @actions
const openYoungHistoryActions = require('actions/openYoungHistory');
const { getChildList } = require('actions/openYoungDashboard');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardError = require('components/commons/wizardError/wizardError');

// @components
const OpenYoungHistoryTableRow = require('components/openYoungHistory/openYoungHistoryTable/openYoungHistoryTableRow');
const OpenYoungHistoryFilter = require('components/openYoungHistory/openYoungHistoryFilter/openYoungHistoryFilter');

// @constants
const { 
    CLEAR_ALL_FILTERS_BUTTON_LABEL,
    DATE_PICKER_CUSTOM_DATE_FORMAT,
    LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY,
} = require('constants/commonsComponents');

// @utilities
const { countActiveFilters } = require('utilities/filtersHelper');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class OpenYoungHistoryView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCardDetailsTab: true,
            openFilter: false,
        }
        this.buildAmountFilterLabel =  this.buildAmountFilterLabel.bind(this);
        this.buildHeader = this.buildHeader.bind(this);
        this.buildNextPageButton = this.buildNextPageButton.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.childListsuccessCallback = this.childListsuccessCallback.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleSetFilter = this.handleSetFilter.bind(this);
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
    }

    componentDidMount() {
        const { immOpenYoungDashboard } = this.props;
        if (!immOpenYoungDashboard.get('openYoungChildList').size) {
            const data = {
                successCallback: this.childListsuccessCallback,
            };
            this.props.getChildList(data);
        } else {
            this.props.getOpenYoungHistory(this.state.isCardDetailsTab);
        }
    }

    componentWillUnmount() {
        this.props.resetOpenYoungHistory();
    }

    childListsuccessCallback() {
        this.props.getOpenYoungHistory(this.state.isCardDetailsTab);
    }

    handleTabClick(evt) {
        const id = evt.currentTarget.id;
        const { isCardDetailsTab } = this.state;
        if( (isCardDetailsTab && id !== 'card') || (!isCardDetailsTab && id !== 'account')) {
            this.props.resetOpenYoungHistory();
            this.setState((prevState) => {
                this.props.getOpenYoungHistory( !prevState.isCardDetailsTab);
                return { isCardDetailsTab: !prevState.isCardDetailsTab };
            });
        }
    }

    handleNextPage() {
        const { immOpenYoungHistory, getOpenYoungHistory } = this.props;
        const { isCardDetailsTab } = this.state;
        const nextPage = immOpenYoungHistory.get('nextPage');
        getOpenYoungHistory(isCardDetailsTab, nextPage);
    }

    handleToggleFilters() {
        this.setState({
            openFilter: !this.state.openFilter
        });
    }

    handleResetFilter(filter) {
        this.props.resetFilter(filter);
        this.handleRetry();
    }

    handleSetFilter(filters) {
        this.props.setFilter(filters);
        this.handleToggleFilters();
        this.handleRetry();
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.handleRetry();
    }

    handleRetry() {
        const { isCardDetailsTab } = this.state;
        this.props.getOpenYoungHistory(isCardDetailsTab);
    }

    buildAmountFilterLabel() {
        const { immOpenYoungHistory } = this.props;
        const immFilter = immOpenYoungHistory.get('filters');
        const plainAmountFromObject = getPlainAmountObject(immFilter.getIn(['amount', 'from']));
        const plainAmountToObject = getPlainAmountObject(immFilter.getIn(['amount', 'to']));
        const language = getLanguage();
        let fromElem = null; 
        let toElem = null;

        if (immFilter.getIn(['amount', 'from', 'amount']) !== null) {
            fromElem = (
                <React.Fragment>
                    <FormattedText value="filters-min" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountFromObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountFromObject, true)} />
                </React.Fragment>
            );
        }

        if (immFilter.getIn(['amount', 'to', 'amount']) !== null) {
            toElem = (
                <React.Fragment>
                    <FormattedText value="filters-max" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountToObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountToObject, true)} />
                </React.Fragment>
            );
        }

        return (
            <LabelFilterRange
                closeCallback={() => this.handleResetFilter('amount')}
                from={fromElem}
                key="filter-amount"
                to={toElem}
            />
        );
    }

    buildDateFilterLabel() {
        const { immOpenYoungHistory } = this.props;
        const labelFromDate = immOpenYoungHistory.getIn(['filters', 'date', 'from']).locale(getLanguage()).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immOpenYoungHistory.getIn(['filters', 'date', 'to']).locale(getLanguage()).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => this.handleResetFilter('date')}
            />
        );
    }

    buildStatusFilterLabel() {
        const { immOpenYoungHistory } = this.props;
        const immFilterStatus = immOpenYoungHistory.getIn(['filters', 'status']);
        if (immFilterStatus.get('isActive')) {
            const selectedStatus = formatText(`openYoungHistoryView-openYoungHistoryView_${immFilterStatus.get('status')}`);
            const statusLabel = formatText('openYoungHistoryFilter-status', [selectedStatus]);
            return (
                <LabelFilterRange
                    from={statusLabel}
                    closeCallback={() => this.handleResetFilter('status')}
                />
            );
        }
    }

    buildChildFilterLabel() {
        const { immOpenYoungHistory } = this.props;
        const immFilter = immOpenYoungHistory.get('filters');
        const immFilterChilds = immFilter.get('childList');
        const childsPanList = immFilterChilds.get('childsPan').filter(immChild => immChild.get('isSelected')).map(immChild => immChild.get('pan'));
        const immChildDetails = immOpenYoungHistory.get('childDetails');
        let childNames = ':';
        childsPanList.forEach(pan => {
            immChildDetails.forEach(immChild => {
                if (pan === immChild.get('pan')) {
                    childNames += immChild.get('childName') + ' ';
                }
            });
        });
        if (immFilterChilds.get('isActive')) {
            const statusLabel = formatText('openYoungHistoryFilter-child', [childNames]);
            return (
                <LabelFilterRange
                    from={statusLabel}
                    closeCallback={() => this.handleResetFilter('childList')}
                />
            );
        }
    }

    buildClearAllFilters() {
        const { immOpenYoungHistory } = this.props;
        const immFilter = immOpenYoungHistory.get('filters');
        let labelElement;
        if (countActiveFilters(immFilter) > 1) {
            labelElement = (
                <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={this.handleClearFilters} />
            );
        }
        return labelElement;
    }

    displayAppliedFilters() {
        const { immOpenYoungHistory } = this.props;
        const immFilter = immOpenYoungHistory.get('filters');
        const immFilterStatus = immFilter.get('status');
        const immFilterDate = immFilter.get('date');
        const immFilterAmount = immFilter.get('amount');
        const immFilterChild = immFilter.get('childList')
        const filterStatusLabel = immFilterStatus.get('isActive') ? this.buildStatusFilterLabel() : '';
        const filterChildLabel = immFilterChild.get('isActive') ? this.buildChildFilterLabel() : '';
        const filterDateLabel = immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';
        const filterAmountLabel = immFilterAmount.get('isActive') ? this.buildAmountFilterLabel() : '';
        const clearAllFilters = this.buildClearAllFilters();
        return(
            <div className="open-young-history-view__applied-filters">
                {filterDateLabel}
                {filterStatusLabel}
                {filterAmountLabel}
                {filterChildLabel}
                {clearAllFilters}
            </div>
        );
    }


    buildNextPageButton() {
        return (
            <footer className="text-right amazon-gift-card-coupons__more-button-container">
                <OKLink modifier="emphasize" onClick={this.handleNextPage}>
                    <FormattedText value="amazonGiftCard-seeMore" />
                </OKLink>
            </footer>
        );
    }

    buildTable() {

        const { immOpenYoungHistory, immOpenYoungDashboard } = this.props;
        const tableHeaders = ['date', 'status', 'operation', 'comment', 'amount'];
        const tableHeaderElements = tableHeaders.map((header,index) => (
            <OKTableCell asHeader={true} key={index}>
                <FormattedText format="uppercase" value={`openYoungHistoryView-openYoungHistoryView_${header}`} />
            </OKTableCell>
        ));
        let lastMovementTable;
        if (immOpenYoungHistory.get('isFetching') || immOpenYoungDashboard.get('isFetchingChildList')) {
            lastMovementTable = (
                <div className="open-young-history-view__content col-xs-12">
                    <LoadingSection />
                </div>
            );
        } else if (immOpenYoungHistory.get('error')) {
            const errorMessage = <FormattedText value="confirmationSolidarityCard-genericError" />;
            lastMovementTable = (
                <div className="open-young-history-view__content col-xs-12">
                    <WizardError errorMessage={errorMessage}>
                        <FormattedText value="confirmationSolidarityCard-genericErrorText" />
                    </WizardError>
                </div>
            );
        } else if(immOpenYoungHistory.get('success')) {
            const { immOpenYoungHistory } = this.props;
            const tableHeader = this.buildTableHeader();
            let nextPageButton = null;
            let nextPageLoadingSection;
            if (immOpenYoungHistory.get('nextPage') && immOpenYoungHistory.get('isFetching')) {
                nextPageLoadingSection = <LoadingSection />;
            } else if (immOpenYoungHistory.get('nextPage')) {
                nextPageButton = this.buildNextPageButton();
            }
            lastMovementTable= (
                <div className="open-young-history-view__content col-xs-12">
                    <OpenYoungHistoryFilter
                        isOpen={this.state.openFilter}
                        immOpenYoungChildDetails={immOpenYoungHistory.get('childDetails')}
                        immFilters={immOpenYoungHistory.get('filters')}
                        onCloseClick={this.handleToggleFilters}
                        onFilterSubmitClick={this.handleSetFilter}
                    />
                    {tableHeader}
                    <LastMovementsTable
                        groupByDate={true}
                        columnsCount={5}
                        id="history-list-table"
                        rowComponent={OpenYoungHistoryTableRow}
                        immTransactionsByOrder={immOpenYoungHistory.get('byOrder')}
                        immTransactionsById={immOpenYoungHistory.get('byId')}
                        onRowClick={this.handleRowClick}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={getLanguage()}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                { tableHeaderElements }
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                    {nextPageLoadingSection}
                    {nextPageButton}
                </div>
            )
        }
        return lastMovementTable;
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-breadcrumb_openYoungDashboard'),
                url: '/myprofile/open-young-dashboard'
            },
            {
                text: formatText('breadcrumb-breadcrumb_historyView'),
                url: ''
            }
        ];

        const headerLeftTabClassName = classNames('open-young-history-view__header-tab', {
            'open-young-history-view__header-tab--active': this.state.isCardDetailsTab,
            'open-young-history-view__header-tab--left': !this.state.isCardDetailsTab
        });
        const headerRightTabClassName = classNames('open-young-history-view__header-tab', {
            'open-young-history-view__header-tab--active': !this.state.isCardDetailsTab
        });
        const headerLeftTabText = classNames('open-young-history-view__header-tab-text', {
            'open-young-history-view__header-tab-text--active': this.state.isCardDetailsTab
        });
        const headerRightTabText = classNames('open-young-history-view__header-tab-text', {
            'open-young-history-view__header-tab-text--active': !this.state.isCardDetailsTab
        });
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <OKCover 
                        size="large"
                        section="cards"
                        customClass="col-xs-12"
                    >
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={formatText('openYoungHistoryView-openYoungHistoryView_historyViewTitle')}
                        >
                        </OKHeaderSubPage>
                        <div className="open-young-history-view__header-tabs">
                            <div id="card" className={headerLeftTabClassName} onClick={this.handleTabClick}>
                                <OKButton modifier="link-ghost">
                                    <FormattedText
                                        className={headerLeftTabText}
                                        value="openYoungHistoryView-openYoungHistoryView_cardHistory"
                                    />
                                </OKButton>
                            </div>
                            <div id="account" className={headerRightTabClassName} onClick={this.handleTabClick}>
                                <OKButton modifier="link-ghost">
                                    <FormattedText
                                        className={headerRightTabText}
                                        value="openYoungHistoryView-openYoungHistoryView_accountHistory"
                                    />
                                </OKButton>
                            </div>
                        </div>
                    </OKCover>
                </div>
            </div>
        );
    }

    buildTableHeader() {
        let headerTitle = (
            <FormattedText
                value="openYoungHistoryView-openYoungHistoryView_historyViewTitle"
            />
        );

        return (
            <header className="open-young-history-view__table-header">
                <div className="open-young-history-view__table-header-title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <div className="open-young-history-view__table-header-filters">
                    <OKButton
                        id="btn_openYoungHistoryHeader_filterButton"
                        modifier="task"
                        onClick={this.handleToggleFilters}
                    >
                        <i className="icon icon-filtrar open-young-history-view__table-header-filter-settings-icon" />
                    </OKButton>
                </div>
                {this.displayAppliedFilters()}
            </header>
        );
    }

    render() {
        const header = this.buildHeader();
        const table = this.buildTable();
        return (
            <div className="open-young-history-view">
                {header}
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row">
                            {table}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
OpenYoungHistoryView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    getChildList: PropTypes.func.isRequired,
    getOpenYoungHistory: PropTypes.func.isRequired,
    immOpenYoungDashboard: PropTypes.object.isRequired,
    immOpenYoungHistory: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    resetOpenYoungHistory: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
}
module.exports.constructor = OpenYoungHistoryView;
module.exports.OpenYoungHistoryView = connect(
    state => ({
        immOpenYoungDashboard: state.openYoungDashboard,
        immOpenYoungHistory: state.openYoungHistory,
    }),
    {
        clearFilters: openYoungHistoryActions.requestClearOpenYoungFilter,
        getChildList,
        getOpenYoungHistory: openYoungHistoryActions.getOpenYoungHistory,
        resetFilter: openYoungHistoryActions.resetOpenYoungHistoryFilter,
        resetOpenYoungHistory: openYoungHistoryActions.resetOpenYoungHistory,
        setFilter: openYoungHistoryActions.setOpenYoungFilter,
    }
)(OpenYoungHistoryView);
